<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vuetable from "vuetable-2";

Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  page: {
    title: "Vehiculos y Modelos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      modelos: [],
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          dataClass: "text-muted",
          width: "15%",
        },
        {
          name: "nombre_modelo",
          sortField: "nombre_modelo",
          title: "Modelo",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "25%",
        },
        // {
        //   name: "linea",
        //   sortField: "linea",
        //   title: "Linea",
        //   titleClass: "",
        //   dataClass: "list-item-heading",
        //   width: "25%",
        // },
        // {
        //   name: "serie",
        //   sortField: "serie",
        //   title: "Serie",
        //   titleClass: "",
        //   dataClass: "list-item-heading",
        //   width: "25%",
        // },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
      ],
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
      },
      formget: {
        nombre: "",
        state: true,
      },
      formSub: {
        nombre: "",
        linea: "",
        serie: "",
        state: true,
        id: 0,
      },
      updating: false,
      title: "Modelos",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Modelos",
          active: true,
        },
      ],

      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,

      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
    };
  },
  validations: {
    formSub: {
      nombre: { required },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detallPresentacion();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    //Detalle Presentacion
    detallPresentacion() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "autos/detalles/view?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.modelos = response.data.detalles;
          this.formget.nombre = response.data.cabecera.nombre_auto;
          this.formget.state = response.data.cabecera.estado_auto;
          // console.log(response.data);
        });
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formSub;
      axios
        .put(
          process.env.VUE_APP_URL + "autos/modelo/desactivate",
          {
            auto: parseInt(this.$route.params.id),
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          this.detallPresentacion();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },
    //Activar registro
    activate() {
      const { id, nombre } = this.formSub;
      axios
        .put(
          process.env.VUE_APP_URL + "autos/modelo/activate",
          {
            auto: parseInt(this.$route.params.id),
            id: id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          this.detallPresentacion();
          this.$refs.vuetable.refresh();
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    //Guardar registro
    save() {
      const { nombre, linea, serie } = this.formSub;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "autos/modelo/store",
          {
            nombre: nombre,
            auto: parseInt(this.$route.params.id),
            serie,
            linea,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          me.detallPresentacion();
          me.$refs.vuetable.refresh();
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const { nombre, id, serie, linea } = this.formSub;
      const me = this;
      axios
        .put(
          process.env.VUE_APP_URL + "autos/modelo/update",
          {
            nombre: nombre,
            id: id,
            auto: parseInt(this.$route.params.id),
            serie,
            linea,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success(nombre + " Actualizado", this.options);
          me.detallPresentacion();
          me.$refs.vuetable.refresh();
          this.showModalE = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },

    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formSub.id = 0;
      this.formSub.nombre = "";
      this.formSub.linea = "";
      this.formSub.serie = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formSub.nombre = data.nombre_modelo;
        this.formSub.serie = data.serie;
        this.formSub.linea = data.linea;
        this.formSub.id = data.id;
      }
      if (action == "new-item") {
        this.formSub.id = 0;
        this.formSub.nombre = "";
      }
      if (action == "desactivate-item") {
        this.formSub.nombre = data.nombre_modelo;
        this.formSub.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formSub.nombre = data.nombre_modelo;
        this.formSub.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar el modelo {{ this.formSub.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>
                    ¿Desea Desactivar el modelo {{ this.formSub.nombre }}?
                  </h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          ref="modalUpdate"
          id="modalUpdate"
          title="Editar Modelo"
          no-close-on-backdrop
          v-model="showModalE"
          @hidden="closeModal('update')"
          @show="openModal('uptade')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Modelo</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.nombre.$model"
                    :state="!$v.formSub.nombre.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un modelo"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.nombre.$error && !$v.formSub.nombre.required,
                    }"
                  >
                    Debe seleccionar un nombre
                  </div>
                </div>
              </div>
              <!-- <div class="col-12">
                <div class="mb-3">
                  <label for="name">Linea</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.linea.$model"
                    :state="!$v.formSub.linea.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una linea"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.linea.$error && !$v.formSub.linea.required,
                    }"
                  >
                    Debe seleccionar una linea
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Serie</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.serie.$model"
                    :state="!$v.formSub.serie.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese serie"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.serie.$error && !$v.formSub.serie.required,
                    }"
                  >
                    Debe seleccionar una serie
                  </div>
                </div>
              </div> -->
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('update')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
          centered
          @show="openModal('save')"
          @hidden="openModal('save')"
          v-model="showModalN"
          id="modalSave"
          ref="modalSave"
          title="Nuevo modelo"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Modelo</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.nombre.$model"
                    :state="!$v.formSub.nombre.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un nombre"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.nombre.$error && !$v.formSub.nombre.required,
                    }"
                  >
                    Debe seleccionar un nombre
                  </div>
                </div>
              </div>
              <!-- <div class="col-12">
                <div class="mb-3">
                  <label for="name">Linea</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.linea.$model"
                    :state="!$v.formSub.linea.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una linea"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.linea.$error && !$v.formSub.linea.required,
                    }"
                  >
                    Debe seleccionar una linea
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Serie</label>
                  <input
                    id="name"
                    v-model.trim="$v.formSub.serie.$model"
                    :state="!$v.formSub.serie.$error"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese serie"
                  />
                  <div
                    :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.formSub.serie.$error && !$v.formSub.serie.required,
                    }"
                  >
                    Debe seleccionar una serie
                  </div>
                </div>
              </div> -->
            </div>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button
                @click="validaciones('save')"
                variant="success"
                class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row justify-content-center">
                <div class="col-xl-8">
                  <div class="text-center">
                    <div class="mb-4">
                      <a href="#" class="badge bg-light font-size-12">
                        <i
                          class="bx bx-purchase-tag-alt align-middle text-muted me-1"
                        ></i>
                        Modelos
                      </a>
                    </div>
                    <h4>Auto</h4>
                  </div>
                  <hr />
                  <div class="text-center">
                    <div class="row">
                      <div class="col-sm-4">
                        <div>
                          <p class="text-muted mb-2">Nombre Vehiculo</p>
                          <h5 class="font-size-15">{{ formget.nombre }}</h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Estado</p>
                          <h5 v-if="formget.state == true">
                            <span class="badge bg-success ms-1"
                              ><strong>ACTIVO</strong></span
                            >
                          </h5>
                          <h5 v-else>
                            <span class="badge bg-danger ms-1"
                              ><strong>INACTIVO</strong></span
                            >
                          </h5>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div>
                          <router-link
                            :to="{
                              name: 'autos',
                            }"
                          >
                            <b-button
                              variant="outline-primary"
                              type="button"
                              class="btn btn-rounded mb-2 me-2"
                            >
                              <i class="mdi mdi-arrow-collapse-left"></i>
                              Regresar
                            </b-button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Modelos</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      v-b-modal.modalSave
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Modelo
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <div class="d-none d-lg-block">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-mode="false"
                :fields="fields"
                :data="modelos"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_modelo"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      v-b-modal.modalUpdate
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_modelo == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_modelo == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_modelo == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_modelo == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              </div>
              <ResponsiveCards :items="modelos">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_modelo" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                  </div>
                  <div class="rwd-card__title">{{ item.nombre_modelo }}</div>
                  <div class="rwd-card__actions">
                    <b-button-group>
                      <b-button
                        v-if="item.estado_modelo"
                        variant="outline-primary"
                        v-b-modal.modalUpdate
                        @click="onActionClicked('edit-item', item)"
                        ><i class="bx bx-edit-alt"></i>
                      </b-button>
                      <b-button
                        :variant="item.estado_modelo == true ? 'outline-danger' : 'outline-success'"
                        @click="
                          item.estado_modelo == true
                            ? onActionClicked('desactivate-item', item)
                            : onActionClicked('activate-item', item)
                        "
                      >
                        <i :class="item.estado_modelo == true ? 'bx bx-trash-alt' : 'bx bx-list-check'"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </ResponsiveCards>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
